<rd-popup-default-template
  [dialogContent]="dialogContent"
  [showButtons]="true"
  [primaryButtonText]="'order.filter_modal.submit' | translate"
  [primaryButtonClass]="'apply-button'"
  [primaryButtonType]="'submit'"
  (primaryButtonClick)="submitDateClick()"
  [showSecondaryButton]="false"
  [onClose]="close">
  <ng-template #dialogContent>
    <rd-auto-redemption-date-picker
      [defaultDate]="dateControl.value"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [formControl]="dateControl"></rd-auto-redemption-date-picker>
  </ng-template>
</rd-popup-default-template>
